import React from 'react';
import {
  useListCommandsQuery, usePreloadCardsQuery,
} from '../../../../../generated/core-api/graphql-react-query';

export default function useContentMaps(projectId?: string) {
  const cards = usePreloadCardsQuery(
    { input: { id: projectId ?? '' } },
    { enabled: !!projectId, cacheTime: 30 * 60 * 1000 },
  );

  const commands = useListCommandsQuery(
    { input: { id: projectId ?? '' } },
    { enabled: !!projectId, cacheTime: 30 * 60 * 1000 },
  );

  const cardTitleMap = React.useMemo(() => {
    const map = new Map<string, string>();
    cards.data?.getProject.scopes.items.forEach((scope) => {
      map.set(scope.cardId, scope.card.title);
    });
    return map;
  }, [cards.data]);

  const commandTitleMap = React.useMemo(() => {
    const map = new Map<string, string>();
    commands.data?.getProject.commands.items.forEach((command) => {
      map.set(command.command.id, command.command.text);
    });
    return map;
  }, [commands.data]);

  return { cardTitleMap, commandTitleMap };
}
